<script lang="ts">
  import CornerIcon from '$icons/CornerIcon.svelte';
  import ProfileBadges from './ProfileBadges.svelte';
  import ImageRender from './images/ImageRender.svelte';

  type UserCardProfile = {
    displayName: string;
    username: string;
    avatarUrl?: string | null;
    accountRoles?: string[];
    batches?: string[];
  };

  export let profile: UserCardProfile;
  export let hover = false;
</script>

<div
  class="gap-x-lg rounded-3xs border-gray-dark-1 relative flex w-full flex-row gap-y-3 border p-1 text-xs text-gray-400 {hover
    ? 'bg-gray-dark-2'
    : 'bg-gray-dark-1'}"
>
  <CornerIcon class="text-gray-dark-12 absolute right-0 top-0 -m-0.5" />
  <CornerIcon class="text-gray-dark-12 absolute bottom-0 left-0 -m-0.5 rotate-180 " />
  <div class="flex justify-between">
    <div class="rounded-px h-12 w-12 overflow-hidden">
      <ImageRender
        src={profile.avatarUrl ?? undefined}
        seed={profile.username}
        imgClass={'rounded-sm'}
      />
    </div>
  </div>
  <div class="flex flex-col items-start gap-y-2 overflow-hidden">
    <div class="flex w-full items-center gap-x-2 text-left">
      <h2 class="overflow-hidden text-ellipsis whitespace-nowrap">
        {profile?.displayName}
      </h2>
      <ProfileBadges roles={profile.accountRoles ?? []} batches={profile.batches ?? []} size="sm" />
    </div>
    <span>@{profile?.username}</span>
  </div>
</div>
